import globals from "./globals";
let {g_sessionList, g_doctorList, setApiToken, getApiToken, setDoctorFullName, getDoctorId, setDoctorId, getOrCreateModalInstance } = globals;

import { processSessions} from "./consult";

const BASE_URL='';

const getToken  = async (userid) => {
    //console.log(`getToken ${userid}`);
    try {
        const response = await fetch(`${BASE_URL}/client-access-token/${userid}`);
        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        console.log(error);
    }
    return null;
};

const externalID = "HOST";

const getSessions = async () => {
    try {
        let apiToken = getApiToken();
        if (!apiToken)
            return;
        const options = { headers: { "token": apiToken}};
        const response = await fetch(`${BASE_URL}/getsessions`, options);
        const jsonResponse = await response.json();
        //console.log('getSessions >>>', jsonResponse);
        g_sessionList = jsonResponse;
        processSessions(g_sessionList);
    } catch (error) {
        console.log("getSessions: ", error);
        logout();
    }
};


const getDoctor = async () => {
    try {
        if (!getApiToken())
            return;

        const options = { headers: { "token": getApiToken()}};
        const response = await fetch(`${BASE_URL}/getdoctor`, options);
        const jsonResponse = await response.json();
        // console.log('getDoctor ', JSON.stringify(jsonResponse));
        setDoctorId(jsonResponse[0].name);
        setDoctorFullName(jsonResponse[0].dr_full_name);

    } catch (error) {
        console.log("getDoctor: ", error);
    }
};

const updateDoctorStatus = async (doctor_status) => {
    if (!getApiToken())
        return;
    // console.log(`updateDoctorStatus ${getDoctorId()} ${doctor_status} ${getApiToken()}`);
    const allow_readmission = (doctor_status ===0) ? 1: 0;
    const params = { doctor_id:getDoctorId(), status: doctor_status };
    const response = await fetch(`${BASE_URL}/updatedoctorstatus`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': getApiToken()
        },
        body: JSON.stringify(params)
    });
    const jsonResponse = await response.json();
    //console.log(jsonResponse);
}

const sendMessage = async (checkin, message) => {
    if (!getApiToken())
        return;
    console.log(`sendMessage ${checkin} ${message}`);
    const params = { checkin, message };
    const response = await fetch(`${BASE_URL}/send-message`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': getApiToken()
        },
        body: JSON.stringify(params)
    });
    const jsonResponse = await response.json();
    //console.log(jsonResponse);
};

const wrapup = async (checkin, status) => {
    if (!getApiToken())
        return;
    //console.log(`wrapup ${checkin} ${status}`);
    const params = { checkin, status };
    const response = await fetch(`${BASE_URL}/wrapup`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': getApiToken()
        },
        body: JSON.stringify(params)
    });
    const jsonResponse = await response.json();
    //console.log(jsonResponse);
};


const findSession = (sessionId) => {
    for (let i=0; i<g_sessionList.length; i++) {
        //console.log('session' + g_sessionList[i] + sessionId);
        if (g_sessionList[i].name === sessionId)
            return g_sessionList[i];
    }
    return null;
};

const savePeerAccessToken = async (checkinId, doctor, peerId, callId, token ) => {
    if (!getApiToken())
        return;
    const params =
        {
            checkin: checkinId,
            accesstoken: token,
            conference: callId,
            doctor,
          };
    const response = await fetch(`${BASE_URL}/save-access-token`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': getApiToken()
        },
        body: JSON.stringify(params)
    });
    const jsonResponse = await response.json();
    //console.log(jsonResponse);
};


const ProviderLogin = async (user, password, cbOk, cbError) => {
    const myModal = getOrCreateModalInstance("ModalForm");
    // let user = username.value;
    // let password = userpassword.value;

    let apiKey = sessionStorage.getItem("api_key");
    if (apiKey !== null) {
        setApiToken(apiKey);
        //console.log('hiding login');
        //console.log('myModal', myModal);
        myModal.hide();
        setTimeout(async () => {
            await getDoctor();
            await updateDoctorStatus('Available');
        }, 100);
        return;
    }

    const params = {user, password};
    const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    });
    const jsonResponse = await response.json();
    // console.log(jsonResponse);
    if (jsonResponse.message === 'Logged In') {
        let apitoken = jsonResponse.apikey;
        sessionStorage.setItem('api_key', apitoken);
        setApiToken(apitoken);
        if (typeof cbOk === 'function') {
            cbOk();
        }
    } else {
        if (typeof cbError === 'function') {
            cbError();
        }
    }
};

const logout = async (cbOk, cbError) => {
    try {
        let token = getApiToken();
        //console.log('token '+ token);
        if (!getApiToken())
            return;

        const options = { headers: { "token": getApiToken()}};
        const response = await fetch(`${BASE_URL}/logout`, options);
        const jsonResponse = await response.json();
        sessionStorage.removeItem('api_key');
        setApiToken(null);

        if (typeof cbOk === 'function') {
            cbOk();
        }

        g_doctorList = [];
        g_sessionList = [];
        // console.log(jsonResponse);
    } catch (error) {
        console.log("logout: ", error);
        sessionStorage.removeItem('api_key');
        setApiToken(null);
        if (typeof cbError === 'function') {
            cbError();
        }
    }
};

function generateUniqueString() {
    var ts = String(new Date().getTime()),
        i = 0,
        out = '';

    for (i = 0; i < ts.length; i += 2) {
        out += Number(ts.substr(i, 2)).toString(36);
    }

    return ('prefix' + out);
}

export  { getToken, ProviderLogin, getDoctor, getSessions, logout, sendMessage, updateDoctorStatus, savePeerAccessToken, wrapup};
